'use strict';
define(function () {
    var constant = {
        ukId: '10151',
        ieId: '10451',
        currencyUk: '£',
        currencyIe: '€'
    };
    return constant;
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/constantvalues.js
 **/